import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Table  } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import { getEmployeeSalaryList, doEmployeeSalaryDelete } from "../../../../../redux/salary/salaryState";
import { NumberFormatter, handleTableChange } from "../../../../../utils/index";
import PopupButton from "components/button/PopupButton";
import SalaryForm from "./SalaryForm";



const SalaryTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
	doDelete, 
	employeeId,
}) => {
	const {getDateRangeColumnFilter} = ColumnSearchFilter();
	
  	const columns = [

	    {
	        title: `Salary Type`,
	        dataIndex: 'salary_type_name',
	        key: 'salary_type_name',
	        width: '12%',
	        render: (salary_type_name) => <span>{salary_type_name}</span>
	    },
	    {
	        title: <div className="text-center">Amount</div>,
	        dataIndex: 'sal_amount',
	        key: 'sal_amount',
	        width: '12%',
	        render: (sal_amount) => <div className="text-right">{NumberFormatter(sal_amount)}</div>
	    },
		{
	        title: `Currency`,
	        dataIndex: 'currency_name',
	        key: 'currency_name',
	        width: '15%',
	        render: (currency_name) => <span>{currency_name}</span>
	    },
	    {
	        title: `Effective Date`,
	        dataIndex: 'sal_effective_date',
	        key: 'sal_effective_date',
	        width: '17%',  
	        ...getDateRangeColumnFilter('sal_effective_date'),
	        render:(sal_effective_date, record) => <span>{`${sal_effective_date ?? ''}`} to {`${record?.sal_end_date ?? 'present'}`}</span> 
	    },
	    {
	        title: <div className="text-center">Notes</div>,
	        dataIndex: 'sal_notes',
	        key: 'sal_notes',
	        width: '33%',
			render: (sal_notes) => <div>{sal_notes ? sal_notes : '_'}</div>
	    },
	    {
	        title: <PopupButton id="add_salary" title="Add Salary" label="Add" btnClass="btn-small">
						<SalaryForm recordId={0} mode="edit" employeeId={employeeId} />
					</PopupButton>,
	        dataIndex: 'sal_id',
	        key: 'sal_id',
	        width: '12%',
	        render:(_, record) => <CrudOption 
									baseRoute={`/console/employees/${employeeId}/employee-salaries`} 
									recordId={record?.sal_id} 
									allowEdit={false}
									deleteHandler={() => doDelete({
										sal_employee_id: record?.sal_employee_id,
										sal_id: record?.sal_id,
									})} 
									viewMode="modal"
									title="Edit Salary"
									viewHandler={(recordId, onCancel) => (
										<SalaryForm 
											recordId={recordId} 
											employeeId={employeeId} 
											mode="edit" 
											onCancel={onCancel} 
										/>
									)}
								/>
	    },
    ];

	useEffect(() => {
		if (employeeId) {
			doSearch({paginate: pagination.per_page, employeeId});
		} 
	}, [doSearch, employeeId, pagination.per_page]);
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.sal_id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
		            onChange={handleTableChange(doSearch, filters)}             	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.salary.employeeSalaryList?.items,
	pagination: state.salary.employeeSalaryList?.pagination,
	filters: state.salary.employeeSalaryList?.filters,
  	requesting: state.salary.employeeSalaryList?.requesting,
  	error: state.salary.employeeSalaryList?.error,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getEmployeeSalaryList(filters)),
  doDelete: (id) => dispatch(doEmployeeSalaryDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SalaryTable);